import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IIntegration } from './types'
import { IntegrationFragment } from './fragments'
import { get } from 'lodash'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  node: IIntegration
  errors: any
}

const mutateHandler = handleFetchResult<IPayload, IIntegration>({
  handler: (data) => get(data, 'viewer.company.integrations.available[0]', {} as IIntegration),
  name: 'Integration',
})

export default function getNode(id: string): Promise<IIntegration> {
  return client.gql.query({ query, variables: { id } }).then(mutateHandler)
}

const query = gql`
  query Integration($id: ID!) {
    viewer {
      company {
        integrations {
          available(id: $id) {
            ...IntegrationFragment
          }
        }
      }
    }
  }
  ${IntegrationFragment}
`
